import { Link } from "react-router-dom";
import { Linkedin, Instagram, Youtube, Facebook, Mail, MapPin } from "lucide-react";
import { ortellyLogo } from "@/assets/images";

const LOGO_URL = ortellyLogo;

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SOCIALS = [
  { name: "X", icon: XIcon, href: "#", testid: "footer-social-x" },
  { name: "Instagram", icon: Instagram, href: "#", testid: "footer-social-instagram" },
  { name: "YouTube", icon: Youtube, href: "#", testid: "footer-social-youtube" },
  { name: "LinkedIn", icon: Linkedin, href: "#", testid: "footer-social-linkedin" },
  { name: "Facebook", icon: Facebook, href: "#", testid: "footer-social-facebook" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-20 border-t border-slate-200 bg-slate-50"
    >
      <div className="container-section grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src={LOGO_URL} alt="Ortelly Systems" className="h-10 w-auto object-contain" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-600">
            Transforming digital workflows with innovation. Makers of PixTraya — the end-to-end photography workflow platform.
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                aria-label={s.name}
                data-testid={s.testid}
                className="flex h-9 w-9 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-600 transition-all duration-200 hover:-translate-y-0.5 hover:border-[#0046B5] hover:text-[#0046B5]"
                title={`${s.name} — coming soon`}
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-slate-900">Company</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/about" data-testid="footer-link-about" className="text-slate-600 hover:text-[#0046B5]">About Us</Link></li>
            <li><Link to="/careers" data-testid="footer-link-careers" className="text-slate-600 hover:text-[#0046B5]">Careers</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-slate-600 hover:text-[#0046B5]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-slate-900">Products & Services</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/products" data-testid="footer-link-pixtraya" className="text-slate-600 hover:text-[#0046B5]">PixTraya</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="text-slate-600 hover:text-[#0046B5]">Integrations</Link></li>
            <li><Link to="/services" data-testid="footer-link-consulting" className="text-slate-600 hover:text-[#0046B5]">Consulting</Link></li>
            <li><Link to="/services" data-testid="footer-link-support" className="text-slate-600 hover:text-[#0046B5]">Technical Support</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-slate-900">Get in touch</h4>
          <ul className="mt-4 space-y-3 text-sm text-slate-600">
            <li className="flex items-start gap-2">
              <Mail className="mt-0.5 h-4 w-4 text-[#0046B5]" />
              <a href="mailto:sales@ortelly.com" className="hover:text-[#0046B5]" data-testid="footer-email">sales@ortelly.com</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 text-[#0046B5]" />
              <span>Hyderabad, Telangana<br />India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200 bg-white">
        <div className="container-section flex flex-col items-center justify-between gap-2 py-6 text-xs text-slate-500 md:flex-row">
          <p>© 2026 Ortelly Systems Private Limited. All rights reserved.</p>
          <p className="flex items-center gap-4">
            <a href="#" className="hover:text-[#0046B5]">Privacy</a>
            <a href="#" className="hover:text-[#0046B5]">Terms</a>
            <a href="#" className="hover:text-[#0046B5]">Cookies</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
